import { Injectable } from '@angular/core';
import { PendingTermDTO } from '@shared/models/interfaces/terms-version.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TermsAcceptanceService {
    private showSignatureSubject = new BehaviorSubject<boolean>(false);
    private pendingTermsSubject = new BehaviorSubject<PendingTermDTO[]>([]);
    private acceptanceResolve: ((value: string[]) => void) | null = null;
    private intendedUrl: string | null = null;

    showSignature$ = this.showSignatureSubject.asObservable();
    pendingTerms$ = this.pendingTermsSubject.asObservable();

    setPendingTerms(terms: PendingTermDTO[]): void {
        this.pendingTermsSubject.next(terms);
    }

    async requestSignature(pendingTerms: PendingTermDTO[]): Promise<string[]> {
        this.pendingTermsSubject.next(pendingTerms);
        this.showSignatureSubject.next(true);

        return new Promise<string[]>((resolve) => {
            this.acceptanceResolve = resolve;
        });
    }

    acceptTerms(signedDocumentIds: string[]): void {
        this.showSignatureSubject.next(false);
        this.pendingTermsSubject.next([]);
        if (this.acceptanceResolve) {
            this.acceptanceResolve(signedDocumentIds);
            this.acceptanceResolve = null;
        }
    }

    setIntendedUrl(url: string): void {
        this.intendedUrl = url;
    }

    getIntendedUrl(): string | null {
        const url = this.intendedUrl;
        this.intendedUrl = null;
        return url === '/login' ? '/dashboard' : url;
    }
}
